<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <transition name="fade">
          <div class="wrapper" v-if="$parent.textPageTitle">
            <div class="title">{{ $parent.textPageTitle }}</div>
            <div class="desc" v-html="$parent.textPageHeader"></div>
            <div class="desc" v-html="$parent.textPageContent"></div>
          </div>
        </transition>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "TextPage",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  created() {
    // Wait for parent to load textPageList before fetching content
    this.$nextTick(() => {
      this.loadPageContent();
    });
  },
  mounted() {
    if (!this.$route.params.slug) {
      this.$router.push({ name: "PageNotFound" });
      return;
    }
    // Only load content if not already loaded
    if (!this.$parent.textPageTitle && this.$route.params.slug) {
      this.loadPageContent();
    }
  },
  methods: {
    loadPageContent() {
      if (this.$route.params.slug) {
        this.$parent.getTextPageContentBySlug(this.$route.params.slug);
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.slug) {
      this.$parent.getTextPageContentBySlug(to.params.slug);
    }
    next();
  },
};
</script>
<style lang="scss" scoped>
.main {
  margin: 40px 0px 80px;
}
</style>
